import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'user-avatar',
  templateUrl: './user-avatar.html',
  styleUrls: ['./user-avatar.scss']
})
export class UserAvatar implements OnInit {

    BASE_URL = environment.IMAGES_URL;

    private _avatarPath: string = '';

    private nonAvatarBorder: string = '';

    @Input()
    set avatarPath(avatarPath: string) {
      // Remove any leading slash character in the avatar path
      let tmp = avatarPath && avatarPath.length && (avatarPath[0] === '/' || avatarPath[0] === '\\') ?
                         avatarPath.substring(1) : (avatarPath || '');
      if(tmp){
        // And add a random suffix to avoid caching in case but only if there is no suffix already
        this._avatarPath = this.BASE_URL + '/' + tmp + (tmp.length && tmp.indexOf('?dummy=') < 0 ?
                          '?dummy='+Math.floor(Math.random()*1000000) : '');
      }else{
        this._avatarPath = '';
      }


    }

    /**
     * Size can be 'small', 'medium' or 'big'.
     */
    @Input() size: string = 'small';

    // assign any css class you want
    @Input() color: string = 'background-color-purple';

    @Input() initial: string;

    @Input() border: string = '';

    constructor() {
    }

    ngOnInit() {
      this.size = 'icon-'+this.size;
      this.nonAvatarBorder = this.border ? 'only-border-white' : '';
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/user-avatar/user-avatar.ts